import { ADMIN_COPY } from './adminCopy';

export const ADMIN_BASE = '/admin';

export const ADMIN_PATHS = {
  DASHBOARD: ADMIN_BASE,
  USERS: `${ADMIN_BASE}/users`,
  COMPANIES: `${ADMIN_BASE}/company`,
  MEMBERS: `${ADMIN_BASE}/members`,
  SITES: `${ADMIN_BASE}/sites`,
  REPORTS: `${ADMIN_BASE}/reports`,
  REPORTS_RECEPTION: `${ADMIN_BASE}/reports/reception`,
  REPORTS_CLINIQUE: `${ADMIN_BASE}/reports/clinique`,
  REPORTS_INFIRMERIE: `${ADMIN_BASE}/reports/infirmerie`,
  REPORTS_PHARMACIE: `${ADMIN_BASE}/reports/pharmacie`,
  SETTINGS: `${ADMIN_BASE}/settings`,
  PHARMACY_CENTRAL: '/pharmacy-central'
};

/** @param {{ canManageUsers: boolean, canManageCompany: boolean, canAccessReports: boolean, canAccessSettings: boolean }} perms */
export function getAdminNavSections(perms) {
  const { canManageUsers, canManageCompany, canAccessReports, canAccessSettings } = perms;
  const N = ADMIN_COPY.NAV;
  const S = ADMIN_COPY.NAV_SECTIONS;

  const dataItems = [
    canManageUsers && { to: ADMIN_PATHS.USERS, end: false, ...N.users },
    canManageCompany && { to: ADMIN_PATHS.COMPANIES, end: false, ...N.companies },
    canManageCompany && { to: ADMIN_PATHS.MEMBERS, end: false, ...N.members },
    canManageCompany && { to: ADMIN_PATHS.SITES, end: false, ...N.sites }
  ].filter(Boolean);

  const reportItems = canAccessReports
    ? [
        { to: ADMIN_PATHS.REPORTS_RECEPTION, end: false, ...N.reportsReception },
        { to: ADMIN_PATHS.REPORTS_INFIRMERIE, end: false, ...N.reportsNursing },
        { to: ADMIN_PATHS.REPORTS_CLINIQUE, end: false, ...N.reportsClinical },
        { to: ADMIN_PATHS.REPORTS_PHARMACIE, end: false, ...N.reportsPharmacy }
      ]
    : [];

  const systemItems = [
    canAccessReports && { to: ADMIN_PATHS.PHARMACY_CENTRAL, end: false, ...N.pharmacyCentral },
    canAccessSettings && { to: ADMIN_PATHS.SETTINGS, end: false, ...N.settings }
  ].filter(Boolean);

  return [
    {
      id: 'overview',
      label: S.overview,
      items: [{ to: ADMIN_PATHS.DASHBOARD, end: true, ...N.dashboard }]
    },
    dataItems.length > 0 && {
      id: 'data',
      label: S.data,
      items: dataItems
    },
    reportItems.length > 0 && {
      id: 'reports',
      label: S.reports,
      items: reportItems
    },
    systemItems.length > 0 && {
      id: 'system',
      label: S.system,
      items: systemItems
    }
  ].filter(Boolean);
}

/** Liste plate — compatibilité */
export function getAdminNavItems(perms) {
  return getAdminNavSections(perms).flatMap((section) => section.items);
}
